import axios from 'axios';

export default function ClinicsPhotogallery() {
  const tabsContainer = document.querySelector('.photo-gallery .slider-heads .tabs-container');
  const tabBtns = document.querySelectorAll('.photo-gallery .slider-heads .tabs-container .tab');
  const dropdownBodyElement = document.querySelector('.photo-gallery .dropdown-item .dropdown-body');
  const loadMoreBtn = document.querySelector('.photo-gallery .loading-more-btn');
  const photosContainer = document.querySelector('.photo-gallery .cards-container .photo-gallery__wrap');

  const filters = {
    category: getActiveTabId(),
    addressId: getActiveAddressId(),
  };

  let page = 2;

  function getActiveTabId() {
    const activeTabElement = document.querySelector('.photo-gallery .slider-heads .tabs-container .tab-active');

    return activeTabElement ? activeTabElement.dataset.tab : '';
  }

  function getActiveAddressId() {
    const DEFAULT_TEXT = 'Выберите адрес';

    const dropdownHeadElement = document.querySelector('.photo-gallery .dropdown-item .dropdown-head');

    if (!dropdownHeadElement) {
      return null;
    }

    const dropdownHeadText = dropdownHeadElement.textContent.trim();

    if (dropdownHeadText === DEFAULT_TEXT) {
      return null;
    }

    const dropdownItems = document.querySelectorAll('.photo-gallery .dropdown-item .body-item');
    const addressElement = Array.from(dropdownItems)
      .find((item) => item.textContent.trim() === dropdownHeadText);

    return Number(addressElement.id);
  }

  if (tabBtns) {
    tabBtns.forEach((tabBtn) => {
      tabBtn.addEventListener('click', async (e) => {
        /** @var {HTMLAnchorElement} */
        const targetElement = e.target;
        const { tab } = targetElement.dataset;

        if (tab === filters.category) {
          return;
        }

        changeActiveTab(targetElement);

        page = 1;
        filters.category = tab;

        clearPhotos();

        await loadMorePhotos();
      });
    });
  }

  /** @param {Element} tabElement */
  function changeActiveTab(tabElement) {
    resetActiveTab();
    setActiveTab(tabElement);

    displayLoadMoreBtn();
  }

  function resetActiveTab() {
    tabsContainer.querySelector('.tab.tab-active').classList.remove('tab-active');
  }

  /** @param {Element} tabElement */
  function setActiveTab(tabElement) {
    tabElement.classList.add('tab-active');
  }

  if (dropdownBodyElement) {
    dropdownBodyElement.addEventListener('click', async (e) => {
      const addressId = Number(e.target.id);

      if (addressId === filters.addressId) {
        return;
      }

      page = 1;
      filters.addressId = addressId;

      displayLoadMoreBtn();

      clearPhotos();

      await loadMorePhotos();
    });
  }

  if (loadMoreBtn && loadMoreBtn.dataset.mediatype === 'photo') {
    loadMoreBtn.addEventListener('click', loadMorePhotos);
  }

  async function loadMorePhotos() {
    try {
      const data = await fetchPhotos();

      if (!data.pageData) {
        hideLoadMoreBtn();
        return;
      }

      renderPhotos(data.pageData);

      page += 1;
    } catch (e) {
      loadMoreBtn.textContent = 'Ошибка при загрузке данных';
    }
  }

  function clearPhotos() {
    photosContainer.innerHTML = '';
  }

  /**
   * @param {string} photos
   */
  function renderPhotos(photos) {
    photosContainer.insertAdjacentHTML('beforeend', photos);
  }

  /**
   * @return {Promise<{ isLastPage: boolean, pageData: string | null }>}
   */
  async function fetchPhotos() {
    const { data } = await axios.get('/api/get-more-photo', {
      params: {
        ...filters,
        page,
      },
    });

    return data;
  }

  function hideLoadMoreBtn() {
    loadMoreBtn.setAttribute('style', 'display: none;');
  }

  function displayLoadMoreBtn() {
    loadMoreBtn.setAttribute('style', 'display: flex;');
  }
}
